import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./SuperChatAI.scss";
import {
  ActionInfoAICard,
  ActionTableAICard,
  GenericSuperAICard,
  OrderStatusTableAICard,
  CreationFailuresAICard,
} from "./SuperAICards";
import { CHAT } from "../../../../util/constants";
import { RegionalLeadOrderTable } from "./SuperChatAIOrderTable/RegionalLeadOrderTable";
import { CopyIcon } from "../../../../icons/copy";

// Renders super agent AI response cards based on message content type
export const SuperChatAI = ({ 
  message, 
  onAddUserMessage, 
  onStatusClick,
  onCheckpointConfirm,
  isCheckpointSubmitting = false,
  checkpointSubmitError = null,
  checkpointSubmitSuccess = false,
}) => {
  const selectedRole = useSelector((state) => state.user?.selectedRole);
  const roleName = typeof selectedRole === 'object'
    ? (selectedRole?.roleName || selectedRole?.name || '').toUpperCase()
    : String(selectedRole || '').toUpperCase();

  const isRegionalLead = roleName === 'REGIONAL LEAD';

  const uiFields = message.ui_fields || [];
  const hasCheckpointPending = message.checkpoint_pending === true;
  const hasUpdateFlag = message.update === true;
  const hasUiFieldsFlag = message.ui_fields_flag === true;

  const renderCard = () => {
    if (message.creationFailures && message.creationFailures.length > 0) {
      return <CreationFailuresAICard message={message} title={CHAT.AXON_AI} />;
    }

    if (message.orderStatusData && message.orderStatusData.length > 0) {
      return (
        <OrderStatusTableAICard
          message={message}
          title={CHAT.AXON_AI}
          onStatusClick={onStatusClick}
        />
      );
    }

    if (message.orders && message.orders.length > 0) {
      return (
        <ActionTableAICard
          message={message}
          title={CHAT.AXON_AI}
          onAddUserMessage={onAddUserMessage}
          TableComponent={
            isRegionalLead || message.useRegionalLeadTable
              ? RegionalLeadOrderTable
              : undefined
          }
        />
      );
    }

    if (!hasCheckpointPending && hasUpdateFlag && hasUiFieldsFlag) {
      const guidanceMessage = {
        ...message,
        text: "To update the requested field(s), please navigate to the Order Details view. Go to \"My Orders\" or \"Smart Suggestions\", then open the order you wish to modify. Thank you.",
        isGenericResponse: true,
      };
      return (
        <GenericSuperAICard
          message={guidanceMessage}
          title={CHAT.AXON_AI}
          onSuggestedQuestionClick={onAddUserMessage}
          checkpointPending={false}
          uiFields={[]}
          onCheckpointConfirm={onCheckpointConfirm}
          isCheckpointSubmitting={isCheckpointSubmitting}
          checkpointSubmitError={checkpointSubmitError}
          checkpointSubmitSuccess={checkpointSubmitSuccess}
        />
      );
    }

    if (message.isGenericResponse) {
      return (
        <GenericSuperAICard
          message={message}
          title={CHAT.AXON_AI}
          onSuggestedQuestionClick={onAddUserMessage}
          checkpointPending={hasCheckpointPending}
          uiFields={uiFields}
          onCheckpointConfirm={onCheckpointConfirm}
          isCheckpointSubmitting={isCheckpointSubmitting}
          checkpointSubmitError={checkpointSubmitError}
          checkpointSubmitSuccess={checkpointSubmitSuccess}
        />
      );
    }

    return (
      <ActionInfoAICard
        message={message}
        title={CHAT.AXON_AI}
        onSuggestedQuestionClick={onAddUserMessage}
      />
    );
  };

  return (
    <div className="super-agent-ai-wrapper">
      {renderCard()}
    </div>
  );
};
